import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import './../Extras/Delivery.css'
import {renderTooltip, transformDelivery} from './../Extras'

const dropdownStyle = {
	backgroundColor: 'white',
	color: 'black',
	maxHeight: '150px',
	// overflowY:'auto',
	// overflowX: 'hidden',
}

const cardStyle = {
	backgroundColor: 'white',
	boxShadow: '2px 3px 5px #E7E7E7',
	borderRadius: 5,
}

const textStyle = {
	fontWeight: 'bold',
	fontSize: 18,
	color: '#2a2a2a'
}

const characters = (color) => ({
	flexShrink: 0,
	padding: '.5em',
	marginRight: '.5em',
	borderRadius: '5px',
	borderStyle: 'solid',
	borderWidth: '1px',
	borderColor: '#e5e5e5',
	backgroundColor: color
})


class Delivery extends React.Component {

	deliveryRegion = () => (
		<div className="col-8 mt-1">
			<DropdownButton
				variant={'white'}
				style={dropdownStyle}
				title={
					this.props.deliveryRegion === '' ? (
						'Seleccione Región'
					) : (
						`${transformDelivery(this.props.deliveryRegion)}`
					)
				}	
			>
				{Object.keys(this.props.delivery).map((region) => {
					if(this.props.delivery[region].communes.length > 0) {
						return(
							<Dropdown.Item key={region} onClick={() => this.props.changeRegion(region, this.props.delivery[region].price)}>
								{transformDelivery(region)}
							</Dropdown.Item>
						)
					}
              return null;
          })
        }
			</DropdownButton>
		</div>
  )

	deliveryCommune = () => (
		<div className="col-8 mt-2">
			{this.props.deliveryRegion !== '' ? (
				<DropdownButton
					variant={'white'}
					id="dropdown-basic-button"
					title={
						this.props.deliveryCommune === '' ? (
							'Seleccione Comuna'
						) : (
							`${this.props.deliveryCommune}`
						)
					}
				>
				  {this.props.delivery[this.props.deliveryRegion].communes.map((commune) => (
						<Dropdown.Item key={commune.label} onClick={() => this.props.changeCommune(commune)}>
							{commune.label}
						</Dropdown.Item>
					  ))
          }
				</DropdownButton>
          ) : (
            ''
          )
      }
		</div>
	)
				
	render() {

		let colorDelivery = null; 
    let colorWithdraw = null; 
    
		if(this.props.deliveryState === true){
			colorDelivery = '#e5e5e5'
		} else if (this.props.deliveryState === false){
			colorWithdraw = '#e5e5e5'
		}

		return (
			<Fragment>
				<div className="row mb-2 pl-2">
					<div 
						className="col-12"
						style={textStyle}
					>
						Selecciona Método de Entrega
					</div>
				</div>

				<div style={{marginBottom: '50px'}} className="row d-flex mt-3 justify-content-center">
					{this.props.toggleDelivery === true || this.props.toggleWhatsAppMethod === true ? 
							<div style={characters(colorDelivery)} onClick={() => this.props.changeDelivery('delivery')}> Delivery </div> 
					: ''}
					{this.props.toggleWithdrawal === true ? 
						<div style={characters(colorWithdraw)} onClick={() => this.props.changeDelivery('withdraw')}> Retiro en Local </div> 
					: ''}
				</div>


				{this.props.toggleDelivery === true && this.props.toggleWhatsAppMethod === true ?
					<div className="row d-flex mb-3 mt-3 justify-content-center">
						<strong> El precio del despacho será evaluado por el dueño al enviar el mensaje </strong>
					</div> 
				 : ''}

				{this.props.deliveryState === true ? 
					<Fragment>
						<div className="row d-flex mb-2" style={textStyle}>
							<div className="col-7"> Datos de Entrega </div>
							<div className="col-5 d-flex justify-content-end align-items-center">
								<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip(this.props.deliveryInformation)}>
									<IoMdInformationCircleOutline />
								</OverlayTrigger>
							</div>
						</div>
							
						<div
							style={cardStyle}
						>
							<div className="d-flex justify-content-center">
								{this.deliveryRegion()}
							</div>
							<div className="d-flex justify-content-center">
								{this.deliveryCommune()}
							</div>
						</div>
          </Fragment> 
          : ''
        }				
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	delivery: state.delivery,
	deliveryInformation: state.deliveryInformation,
	dispatchTime: state.dispatchTime,
	shopDirection: state.shopDirection,
	toggleWithdrawal: state.toggleWithdrawal,
	toggleDelivery: state.toggleDelivery,
	toggleWhatsAppMethod: state.toggleWhatsAppMethod
});

export default connect(mapStateToProps, null)(Delivery);


